/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCorrectionGridQueryResponse,
  GetApiV1ExamCorrectionGridQueryParams,
  GetApiV1ExamCorrectionGrid400,
  GetApiV1ExamCorrectionGrid401,
  GetApiV1ExamCorrectionGrid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGrid.ts";

function getGetApiV1ExamCorrectionGridUrl() {
  const res = { method: "GET", url: `/api/v1/exam/correction-grid` as const };
  return res;
}

/**
 * @description Retorna a grade de correção de texto para uma publicação de exame específica com paginação. **(Requer Authorization para autenticação)**
 * @summary Carregar a grade de correção do exame (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-grid}
 */
export async function getApiV1ExamCorrectionGrid(
  params?: GetApiV1ExamCorrectionGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCorrectionGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGrid400
      | GetApiV1ExamCorrectionGrid401
      | GetApiV1ExamCorrectionGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCorrectionGridUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
